import React, { useEffect, useState } from "react";

import { AiOutlineInstagram } from "react-icons/ai";
import { FaQuestion, FaUserCircle, FaMapPin } from "react-icons/fa";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import FooterLogo from "../../Assets/RedcliffeImagingFooter.png";
import { FiMail, FiPhone } from "react-icons/fi";
import { Scroll, ScrollToposition } from "../Scroll function/scroll";
import "../../components/Footer/Footer.css";
import { useSelector, useDispatch, connect } from "react-redux";
import {
  EmptyCart,
  getCartDetails,
  postFrenchiseInfo,
} from "../../Redux/Actions";
import { Modal } from "react-responsive-modal";
import metroCross from "../../Assets/metroCross.svg";
import PatientActions from "../Cart/PatientDetailsAction";

const ImagingFooter = (props) => {
  const { screen, telNumber, email, noFaq } = props;
  const history = useHistory();
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const cart = useSelector((state) => state.CartReducer);
  const { loading: loadingCity, citySelect } = citySelected;
  const [open, setOpen] = useState(false);
  const [openModalCollectionCenter, setopenModalCollectionCenter] = useState(
    false
  );

  const { loading: loadingCart, cartDetails } = cart;

  const [navTo, setNavTo] = useState("/");

  const onOpenModal = (navTo) => {
    setNavTo(navTo);
    const user = localStorage.getItem("user");
    if (!user) {
      // history.push(navTo);
      window.location.href = process.env.RAZZLE_APP_BASE_URL + navTo;
    } else if (
      cart?.cartDetails &&
      cart?.cartDetails?.message == "cart is empty"
    ) {
      // history.push(navTo);
      window.location.href = process.env.RAZZLE_APP_BASE_URL + navTo;
    } else if (cart?.cartDetails && cart?.cartDetails[0].product?.length == 0) {
      // history.push(navTo);
      window.location.href = process.env.RAZZLE_APP_BASE_URL + navTo;
    } else {
      setTimeout(() => {
        setOpen(true);
      }, 400);
    }
  };

  const onCloseModal = () => setOpen(false);
  // useEffect(()=>{
  //         window.location.reload();
  // },[])
  margin: ;
  const dispatch = useDispatch();
  const handleSubmit = () => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    if (userProfile && userProfile !== "") {
      dispatch(EmptyCart(userProfile && userProfile.token));
      setTimeout(() => {
        history.push(navTo);
      }, 400);
    }
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("user"))) {
      const userProfile = JSON.parse(localStorage.getItem("user"));
      dispatch(getCartDetails(userProfile?.token));
    }
  }, []);

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props.getProfileDetails(token);
    }
  }, []);

  const onCollectionCenterClick = () => {
    document.cookie = "_v=version-1;max-age=2592000;path=/"
    window.location.href = process.env.RAZZLE_APP_BASE_URL + "/franchising-opportunities"
  }

  const FooterForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [email, setemail] = useState("");
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [Name, setName] = useState("");
    const [newNameError, setNewNameError] = useState("");
    const [phonenumError, setPhonenumError] = useState("");

    useEffect(() => {
      if (props?.userProfile?.username && props?.userProfile?.fullname) {
        setPhoneNumber(props?.userProfile?.phonenumber);
        setName(props?.userProfile?.fullname);
        setemail(props?.userProfile?.email);
      }
    }, [props?.userProfile]);

    const styles = {
      form__input: {
        marginBottom: "0rem",
      },
      main__input: {
        marginBottom: "0rem",
      },
      ioicon_margin: {
        marginRight: "6px",
      },
    };

    const handleUserName = (e) => {
      setName(e.target.value);
      const characterRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      setNewNameError("");

      if (!e.target.value.match(characterRegex)) {
        setNewNameError("Enter a valid name");
      }
      if (e.target.value == "") {
        setNewNameError("");
      }
    };

    const handlePhoneNumber = (e) => {
      setPhoneNumber(e.target.value);
      let characterRegex = /^[0-9]{1}$/g;
      let mb = /^[0-9\b]+$/;
      setPhonenumError("");
      if (e.target.value.match(characterRegex)) {
        setPhonenumError("Enter a valid number");
      }
      if (e.target.value.length != 10) {
        setPhonenumError("Enter a valid number");
      }
      if (e.target.value.length != 10 && mb.test(e.target.value) == true) {
        setPhonenumError("Enter a valid number.");
      }
      if (
        e.target.value.length == 10 &&
        e.target.value.charAt(0) >= 6 &&
        mb.test(e.target.value) == true
      ) {
        setPhonenumError("");
      }
      if (e.target.value == "") {
        setPhonenumError("");
      }
    };

    const handleEmail = (e) => {
      setemail(e.target.value);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      const frenchiseBody = {
        name: Name,
        mobile: PhoneNumber,
        message: email,
        url: "https://redcliffelabs.com/franchising-opportunities"
      };
      dispatch(postFrenchiseInfo(frenchiseBody))
      history.push("/franchising-opportunities")

    }
    return (
      <div className="LoginFormDivHome">
        {/* <CommonForm /> */}

        <form className="modal-form login-form " onSubmit={handleSubmit}>
          <div className="form__div">
            {/* <h4>Book Your Test</h4> */}
            <h2
              style={{
                fontSize: "3rem",
                margin: "2rem 0",
                color: "#707070",
              }}
              className="ForMargin"
            >
              Get In Touch With Us
            </h2>
            <p className="para1 ForMargin">
              Feel Free to Connect With Us For Any Queries
            </p>
            <div className="input_container">
              <div className="form__input ForMargin" style={styles.form__input}>
                <span className="userIcon">
                  <FaUserCircle />
                </span>
                <div className="inputDiv">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    onChange={handleUserName}
                    value={Name}
                    style={styles.main__input}
                    required
                  />
                </div>
              </div>
              <span id="errorMessage">{newNameError}</span>
            </div>

            {/* <div className="phone_number">
                      +91 */}
            <div className="input_container">
              <div
                className="form__input numBox ForMargin"
                style={styles.form__input}
              >
                <span className="numIcon">+91</span>
                <div className="inputDiv">
                  <input
                    type="number"
                    placeholder="Enter Phone Number"
                    required
                    onChange={handlePhoneNumber}
                    value={PhoneNumber}
                    style={styles.main__input}
                  />
                </div>
              </div>
              <span id="errorMessage">{phonenumError}</span>
            </div>

            {/* </div>   */}
            <div className="citySelect ForMargin" style={styles.form__input}>
              <span className="locIcon" style={styles.ioicon_margin}>
                {" "}
                <FiMail />{" "}
              </span>

              <input
                type="email"
                placeholder="Enter Email"
                onChange={handleEmail}
                value={email}
                style={styles.main__input}
                required
              />
            </div>

            <button
              className="popupBtn"
              type="submit"
              disabled={newNameError !== "" || phonenumError !== ""}
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="MainFooterWrapper">
      <div className="footer">
        <footer>
          {/* <ScrolltoTop /> */}
          <div className="footer-content">
            <div className="about col-xs-12 col-sm-6 col-md-3">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/39350684-4581-4a0d-b297-52fb3452aa93.webp"
                alt="Logo"
                onClick={() => Scroll()}
                className="imgFooterLogo"
              />

              <p className="footer-des">
                Redcliffe Imaging (a unit of Redcliffe Lifetech Inc) offers a
                comprehensive range of radiology services through its wide
                network of diagnostic centres. The imaging services are best in
                class with use of world-class technology, quick turnaround time,
                accurate and reliable reports.
              </p>
              {/* <li className={""} style={{listStyle:"none"}}>
                    <a href="//www.dmca.com/Protection/Status.aspx?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9" title="DMCA.com Protection Status" className="dmca-badge"> <img src ="https://images.dmca.com/Badges/_dmca_premi_badge_1.png?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9"  alt="DMCA.com Protection Status" /></a>
                    </li> */}
            </div>
            <div className="FooterTwoDiv">
              <div className="usefull-links col-xs-12 col-sm-6 col-md-3">
                <h2>Quick Links</h2>
                <ul
                  onClick={() => {
                    Scroll();
                  }}
                  className="links"
                  style={{ listStyleType: "none" }}
                >
                  {/* <ul className="links" style={{ listStyleType: "none" }}> */}
                  <li className={""}>
                    <div
                      onClick={() => {
                        onOpenModal("/");
                      }}
                    >
                      Home
                    </div>
                    {/* <a href={process.env.RAZZLE_APP_BASE_URL}>Home</a> */}
                  </li>
                  <li className={""}>
                    <Link
                      to={`/imaging/health-checkup-packages${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Imaging Tests
                    </Link>
                  </li>
                  <li className={""}>
                    <div
                      onClick={() => {
                        onOpenModal("/about-us");
                      }}
                    >
                      About Us
                    </div>
                    {/* <Link to="/about-us">About us</Link> */}
                  </li>
                  <li className={""}>
                    <Link to="/imaging/contact">Contact us</Link>
                  </li>
                  <li className={""}>
                    {/* <div
                      onClick={() => {
                        onOpenModal("/franchising-opportunities");
                      }}
                    >
                      Partner With Us
                    </div> */}
                    {/* <Link to="/franchising-opportunities"></Link> */}
                  </li>

                  <li className={""}>
                    <div
                      onClick={() => {
                        onOpenModal("/blog");
                      }}
                    >
                      My Health
                    </div>
                    {/* <Link to="/blog" onClick={() => Scroll()}>
                      Blogs{" "}
                    </Link> */}
                  </li>
                  <li className={""}>
                    {/* <a href={process.env.RAZZLE_APP_BASE_URL + "/franchising-opportunities"}>
                      Collection Center Partner
                    </a> */}
                    <span onClick={onCollectionCenterClick} >
                      Collection Center Partner
                    </span>
                  </li>
                  {/* {noFaq ? (
                    <li>
                      <span onClick={() => ScrollToposition(screen)}>FAQs</span>
                    </li>
                  ) : null} */}
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/redcliffelabs-in-association-with-wolters-kluwer"}>{"Doctors Portal > UpToDate Subscription"}</a>
                  </li>
                </ul>
              </div>

              <div className="services col-xs-12 col-sm-6 col-md-3">
                <h2>Popular Packages</h2>

                <ul
                  // onClick={() => {
                  //   Scroll();
                  // }}
                  className="links"
                  style={{ listStyleType: "none" }}
                >
                  <li onClick={() => { }} className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/smart-full-body-checkup${citySelected?.citySelect
                        ? `-${citySelected?.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Smart Full Body Checkup
                    </a>
                  </li>

                  <li className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/kidney-function-test-kft${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Kidney Function Test
                    </a>
                  </li>

                  <li className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/liver-function-test-lft${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Liver Function Test
                    </a>
                  </li>

                  <li value="rtpcr" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/covid-rtpcr-test${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Covid - 19 RTPCR
                    </a>
                  </li>
                  <li value="advance-full-body-checkup" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/advance-full-body-checkup${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Advance Full Body Checkup
                    </a>
                  </li>

                  <li value="smart-plus-full-body-checkup" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/healthy-heart-package${citySelect
                        ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Healthy Heart Package
                    </a>
                  </li>
                  <li value="black-fungus-mucormycosis" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/blood-sugar-test-package${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Blood Sugar Test
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              id="contact-details"
              className="contact-info col-xs-12 col-sm-6 col-md-3"
            >
              <h2>Follow us on</h2>
              <div className="followUs__icon">
                <span>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/redcliffelabs/"
                    className="followUs__link"
                  >
                    <AiOutlineInstagram />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/RedcliffeLabs/"
                    className="followUs__link"
                  >
                    <FaFacebookF />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://twitter.com/redcliffelab"
                    className="followUs__link"
                  >
                    <FaTwitter />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/redcliffe-labs/"
                    className="followUs__link"
                  >
                    <FaLinkedinIn />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/c/RedcliffeLabs"
                    className="followUs__link"
                  >
                    <FaYoutube />
                  </a>
                </span>
              </div>

              <h2 className="contactUsH2">Contact </h2>
              <div className="contactUs__icon">
                <div className="contactIconsDiv">
                  <a
                    href="mailto:care@redcliffelabs.com"
                    className="followUs__link"
                  >
                    <FiMail />
                  </a>
                  <a href="mailto:care@redcliffelabs.com">
                    {email ? email : "care@redcliffelabs.com"}
                  </a>
                </div>

                <div className="contactIconsDiv">
                  <a href={`tel:+91${telNumber}`} className="followUs__link">
                    <FiPhone />
                  </a>

                  <a href={`tel: +91${telNumber}`}>{telNumber}</a>
                </div>

                <div className="contactIconsDiv">
                  <Link to="/imagine-query" className="followUs__link">
                    <FaQuestion />
                  </Link>
                  <Link to="/imagine-query">Query</Link>

                </div>
                <div className="DMCADiv">
                  <a
                    href="//www.dmca.com/Protection/Status.aspx?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9"
                    title="DMCA.com Protection Status"
                    className="dmca-badge"
                  >
                    {" "}
                    <img
                      src="https://www.dmca.com/PP2020/images/status/logo-w.png"
                      alt="DMCA.com Protection Status"
                      className="DMCAImg"
                    />
                  </a>
                  <p className="DMCAPara">
                    The Content on this websites is DMCA protected
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr
            style={{
              margin: "2rem 0",
              border: "0",
              borderTop: "1px solid #ddd",
            }}
          />
          <div className="bottom-content">
            <div className="copyright">
              <div className="insideCopyright">
                <a href={process.env.RAZZLE_APP_BASE_URL}>Redcliffe Labs </a>{" "}
              </div>
              <p style={{ margin: "0" }}> © 2022. All rights reserved.</p>
            </div>
            <div className="social-icons">
              <a href={process.env.RAZZLE_APP_BASE_URL + "/terms-of-use"}>Terms of Use</a>
              <a href={process.env.RAZZLE_APP_BASE_URL + "/privacy-policy"}>Privacy Policy</a>
            </div>
          </div>
          <div className="bottom-content">
            <div
              className="copyright"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <p
                style={{ margin: "0", marginTop: "1rem", marginBottom: "5rem" }}
              >
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
            </div>
          </div>
        </footer>
      </div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div onClick={onCloseModal} className="modalCloseButton">
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <h2>Are you sure you want to empty your cart?</h2>
          <div className="modal-inner">
            <Link to="/imaging" className="modal-link" onClick={onCloseModal}>
              No
            </Link>
            <div className="modal-link" onClick={handleSubmit}>
              Yes{" "}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={openModalCollectionCenter}
        onClose={() => {
          setopenModalCollectionCenter(false);
        }}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div
          onClick={() => {
            setopenModalCollectionCenter(false);
          }}
          className="modalCloseButton"
        >
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <FooterForm />
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
    leadGenrated: (body) => {
      dispatch(uploadLp(body));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(ImagingFooter));
